:root { --mq-desktop-header-height: 56px; --mq-desktop-space-sm: 8px; --mq-desktop-space-md: 16px; --mq-desktop-font-size: 16px; --mq-desktop-line-height: 20px; }

/* Preserve the shared header grid/flex layout while grouping lockable actions. */
.mu-desktop-actions { display: contents; }
.mu-desktop-actions[inert] > * { opacity: var(--ant-opacity-loading, 0.65); }


html.mu-desktop-shell {
  --mu-desktop-chrome-offset: var(--mq-desktop-header-height);
  --mu-desktop-header-z: 11000;
  --mu-desktop-popup-z: 12000;
  --mu-desktop-overlay-top: calc(var(--critical-issue-banner-height, 0px) + var(--mu-desktop-chrome-offset));
  --mu-fullscreen-inset: var(--mu-desktop-overlay-top) 0 0 0;
  --mu-desktop-rule-color: color-mix(in srgb, var(--ant-color-text, CanvasText) 12%, var(--ant-color-bg-container, Canvas));
  /* Linker Freiraum für die macOS-Ampelknöpfe bei Electron hiddenInset. */
  --mu-desktop-traffic-lights-inset: 78px;
}

html.mu-desktop-shell body {
  -webkit-app-region: no-drag;
  app-region: no-drag;
}

/* Native Windows-Maße sind unabhängig vom Anzeigezoom des Dokuments. */
html.mu-desktop-platform-win32.mu-desktop-shell {
  --mq-desktop-header-height: calc(56px / var(--mq-display-zoom, 1));
}

.mu-desktop-titlebar,
.mu-app-shell-header--desktop {
  --mq-frame-top-height: var(--mq-desktop-header-height);
  -webkit-app-region: drag;
  app-region: drag;
  box-sizing: border-box;
  user-select: none;
}

html.mu-desktop-shell .mq-frame--with-top {
  --mq-frame-top-height: var(--mq-desktop-header-height);
}

.mu-app-shell-header--desktop .mq-frame-top-actions {
  flex-shrink: 0;
}

.mu-app-shell-header--desktop {
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  width: 100% !important;
  height: var(--mq-desktop-header-height) !important;
  padding-inline: 0 !important;
  overflow: visible !important;
  isolation: isolate;
  z-index: var(--mu-desktop-header-z) !important;
  border-bottom: 0 !important;
  /* Gleiche Fläche wie die Navigation (app-frame.css, obere Zeile). */
  background: var(--mq-theme-rail, var(--ant-color-bg-container, Canvas));
  color: var(--mq-theme-rail-strong, var(--ant-color-text));
  box-shadow: none !important;
}

.mu-desktop-titlebar {
  position: fixed;
  z-index: var(--mu-desktop-header-z) !important;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: var(--mq-desktop-header-height);
  display: flex;
  align-items: center;
  color: var(--mq-theme-rail-strong, var(--ant-color-text));
  border-bottom: 0;
  isolation: isolate;
  background: var(--mq-theme-rail, var(--ant-color-bg-container, Canvas));
  box-shadow: none !important;
}

html.mu-desktop-shell::after {
  content: "";
  position: fixed;
  left: 0;
  right: 0;
  width: 100%;
  top: calc(var(--mq-desktop-header-height) - 1px);
  height: 1px;
  z-index: calc(var(--mu-desktop-header-z) + 1);
  pointer-events: none;
  background: var(--mu-desktop-rule-color);
}

html.mu-desktop-platform-win32.mu-desktop-shell::after {
  top: calc(env(titlebar-area-height, 55px) / var(--mq-display-zoom, 1));
  height: calc(1px / var(--mq-display-zoom, 1));
}

html.mu-desktop-platform-win32 .mu-app-shell-header--desktop,
html.mu-desktop-platform-win32 .mu-desktop-titlebar {
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  right: 0 !important;
  height: var(--mq-desktop-header-height) !important;
  padding-right: calc((100vw - env(titlebar-area-width, 100vw)) / var(--mq-display-zoom, 1)) !important;
}

html.mu-desktop-platform-darwin .mu-app-shell-header--desktop,
html.mu-desktop-platform-darwin .mu-desktop-titlebar {
  padding-left: var(--mu-desktop-traffic-lights-inset);
}

.mu-desktop-titlebar-spacer {
  flex: 1 1 auto;
  min-width: 24px;
  align-self: stretch;
  -webkit-app-region: drag;
  app-region: drag;
}

.mu-desktop-titlebar button,
.mu-desktop-titlebar a,
.mu-app-shell-header--desktop button,
.mu-app-shell-header--desktop a,
.mu-desktop-caption-buttons,
.mu-desktop-caption-button,
.mu-app-shell-header--desktop .ck-avatar,
.mu-app-shell-header--desktop .ck-select {
  -webkit-app-region: no-drag;
  app-region: no-drag;
}

.mu-desktop-no-drag {
  -webkit-app-region: no-drag;
  app-region: no-drag;
}

.mu-app-shell-header--desktop .mu-desktop-no-drag {
  align-self: stretch;
  height: 100%;
}

html.mu-desktop-shell .ck-dropdown,
html.mu-desktop-shell .ck-tooltip,
html.mu-desktop-shell .ck-popover,
html.mu-desktop-shell .ck-select-dropdown,
html.mu-desktop-shell .ck-picker-dropdown {
  -webkit-app-region: no-drag;
  z-index: var(--mu-desktop-popup-z) !important;
}

.mu-desktop-app-menu,
.mu-desktop-caption-button {
  -webkit-app-region: no-drag;
  display: inline-flex;
  align-items: center;
  height: 100%;
  min-height: 100%;
  margin: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  cursor: pointer;
}

.mu-desktop-app-menu {
  gap: var(--mq-desktop-space-sm);
  padding: 0 var(--mq-desktop-space-md);
  font-weight: 600;
  font-size: var(--mq-desktop-font-size);
  line-height: var(--mq-desktop-line-height);
}

.mu-desktop-app-menu-icon {
  width: 28px;
  height: 28px;
  flex: 0 0 auto;
  object-fit: contain;
}

.mu-desktop-app-menu-title {
  letter-spacing: 0.01em;
}

.mu-desktop-app-menu-chevron {
  width: 12px;
  height: 12px;
  flex: 0 0 auto;
}

.mu-desktop-caption-buttons {
  display: flex;
  align-self: stretch;
  height: 100%;
  flex: 0 0 auto;
}

.mu-desktop-caption-button {
  justify-content: center;
  flex: 0 0 46px;
  width: 46px;
  min-width: 46px;
  padding: 0;
}

.mu-desktop-caption-button svg {
  width: 10px;
  height: 10px;
  display: block;
}

.mu-desktop-app-menu:hover,
.mu-desktop-app-menu.is-open,
.mu-desktop-caption-button:hover {
  background-color: color-mix(in srgb, currentColor 12%, transparent);
}

.mu-desktop-caption-close:hover {
  background: var(--ant-color-error);
  color: var(--ant-color-text-light-solid);
}

.mu-desktop-app-menu:focus,
.mu-desktop-caption-button:focus {
  outline: none;
}

.mu-desktop-app-menu:focus-visible,
.mu-desktop-caption-button:focus-visible {
  outline: 2px solid currentColor;
  outline-offset: -2px;
}
